<ndc-dynamic
    [ndcDynamicComponent]="basicWidgetComponent$ | async"
    [ndcDynamicInputs]="{ config: basicWidgetComponentConfig, context: context }"
    [ndcDynamicOutputs]="{}"
/>
